import { LegalPageLayout } from "@/components/LegalPageLayout";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function CookieTajekoztato() {
  const openCookieSettings = () => {
    window.dispatchEvent(new Event("open-cookie-settings"));
  };

  return (
    <LegalPageLayout
      eyebrow="Cookie tájékoztató"
      title="Cookie tájékoztató"
      hatalyos="2026. június 11-től"
    >
      <p>
        A <strong>fortunaponyva.hu</strong> weboldal sütiket, azaz cookie-kat
        használhat a weboldal működtetése, biztonsága, statisztikai elemzése és
        — hozzájárulás esetén — marketing célok érdekében.
      </p>

      <h2>1. Mik azok a cookie-k?</h2>
      <p>
        A cookie-k kis adatfájlok, amelyeket a böngésző ment el a felhasználó
        eszközén. Ezek segíthetnek például abban, hogy a weboldal megfelelően
        működjön, megjegyezze a felhasználói beállításokat, vagy statisztikai
        információkat adjon a weboldal használatáról.
      </p>

      <h2>2. Milyen cookie-kat használhat a weboldal?</h2>

      <h3>Feltétlenül szükséges cookie-k</h3>
      <p>
        Ezek a sütik a weboldal alapvető működéséhez szükségesek. Nélkülük a
        weboldal bizonyos funkciói nem működnének megfelelően.
      </p>
      <ul>
        <li><strong>Jogalap:</strong> jogos érdek</li>
        <li><strong>Hozzájárulás:</strong> nem szükséges</li>
        <li><strong>Példák:</strong> munkamenet-cookie, biztonsági cookie, cookie-beállításokat tároló süti</li>
      </ul>

      <h3>Statisztikai cookie-k</h3>
      <p>
        Ezek a sütik segítenek megérteni, hogyan használják a látogatók a
        weboldalt. Például mely oldalakat nézik meg, mennyi időt töltenek az
        oldalon, és honnan érkeznek.
      </p>
      <ul>
        <li><strong>Jogalap:</strong> hozzájárulás</li>
        <li><strong>Példa:</strong> Google Analytics, ha használatban van</li>
      </ul>

      <h3>Marketing cookie-k</h3>
      <p>
        Ezek a sütik hirdetési, remarketing vagy konverziómérési célokat
        szolgálhatnak.
      </p>
      <ul>
        <li><strong>Jogalap:</strong> hozzájárulás</li>
        <li><strong>Példák:</strong> Google Ads, Facebook Pixel, Meta Pixel, TikTok Pixel, ha használatban vannak</li>
      </ul>

      <h2>3. Cookie-k kezelése</h2>
      <p>
        A látogató a weboldalra érkezéskor beállíthatja, hogy mely cookie-k
        használatához járul hozzá.
      </p>
      <p>
        A nem szükséges cookie-k csak akkor aktiválódhatnak, ha a látogató
        ehhez előzetesen hozzájárult. Ez különösen fontos statisztikai és
        marketing célú sütiknél.
      </p>
      <p>
        A látogató a böngészője beállításaiban is törölheti vagy letilthatja a
        sütiket. A sütik letiltása azonban befolyásolhatja a weboldal
        működését.
      </p>

      <div className="not-prose mt-8 p-6 bg-[#F8FAFC] border-l-4 border-[#EA580C] rounded-md">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 text-[#EA580C] mt-0.5 shrink-0" />
          <div>
            <h4 className="font-heading font-bold text-[#0B192C] text-lg">
              Cookie-beállítások módosítása
            </h4>
            <p className="mt-1 text-sm text-gray-600">
              Bármikor módosíthatja az itt megadott hozzájárulásait.
            </p>
            <Button
              data-testid="open-cookie-settings-btn"
              onClick={openCookieSettings}
              className="mt-3 bg-[#EA580C] hover:bg-[#C2410C] text-white h-10"
            >
              Cookie-beállítások megnyitása
            </Button>
          </div>
        </div>
      </div>

      <h2>4. Cookie-beállítási kategóriák</h2>

      <h3>Szükséges sütik</h3>
      <p>
        Ezek a sütik a weboldal alapvető működéséhez szükségesek, ezért nem
        kapcsolhatók ki.
      </p>

      <h3>Statisztikai sütik</h3>
      <p>
        Ezek segítenek megérteni, hogyan használják a látogatók a weboldalt,
        hogy javítani tudjuk annak működését és tartalmát.
      </p>

      <h3>Marketing sütik</h3>
      <p>
        Ezek hirdetési és remarketing célokat szolgálnak, például relevánsabb
        hirdetések megjelenítéséhez.
      </p>
    </LegalPageLayout>
  );
}
